import RpcError from './RpcError'

const JABSORB_JAVA_CLASS_FIELD = 'javaClass'
const JAVA_MAP = 'java.util.Map'

/**
 * Wrap simple key value object to sent via rpc for service java.util.Map parameter
 * */
export const map = (obj) => ({
    [JABSORB_JAVA_CLASS_FIELD]: JAVA_MAP,
    map: obj
})

export const isAborted = (error) => {
    return (error instanceof RpcError) && error.getTextStatus() === 'abort'
}



// WEBPACK FOOTER //
// ./web/js/util/rpc/rpcUtils.js